import React from "react";
import Head from "next/head";
import dynamic from "next/dynamic";

const List = dynamic(() => import("../../components/UI/List"));
const CareersBlock = dynamic(() => import("../../components/sections/Careers"));

export default function Careers(props) {
  const { records = [] } = props?.vacancies;
  return (
    <div className="wrapper">
      <Head>
        <title>Careers at Apphud - Apphud</title>
        <link rel="canonical" href="https://apphud.com/careers" />
        <meta property="og:title" content="Careers at Apphud - Apphud" />
        <meta
          name="description"
          content="Join our team and create the best mobile purchase platform with us!"
        />
      </Head>
      <CareersBlock isEmpty={records.length === 0}>
        <List
          items={records.map((vacancy, key) => (
            <div key={key}>
              <a
                href={vacancy.fields.url}
                target="_blank"
                title={vacancy.fields.Name}
              >
                {vacancy.fields.Name}
              </a>
            </div>
          ))}
        />
      </CareersBlock>
    </div>
  );
}

export async function getServerSideProps() {
  const res = await fetch(
    "https://api.airtable.com/v0/appxYMuWB6OagaQJ9/Careers?sort[0][field]=Name",
    {
      headers: {
        Authorization: "Bearer keyv0tjpvAHbF7Vme",
      },
    }
  );
  return {
    props: {
      vacancies: await res.json(),
    },
  };
}
